import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { handleDynamicCalltracking, EPageTypes, EPlatformTypes } from '@cian/frontend-newbuilding-call-component';

import { INewbuildingBuilder, ISeller } from '../../types/newbuilding/builder';
import { isTablet } from '../../utils/window/isTablet';
import { cropPhone } from '../../utils/phone/cropPhone';
import { useApplicationContext } from '../../utils/applicationContext';
import { stringToFormattedPhone } from '../../utils/phone/stringToFormattedPhone';

interface ICallSellerProps {
  blockId?: number | null;
  target: INewbuildingBuilder | ISeller;
  placeType: string;
  trackAction(builder: INewbuildingBuilder | ISeller): void;
}

export const CallSeller: React.FC<ICallSellerProps> = ({ target, placeType, blockId, trackAction }) => {
  const { httpApi, logger } = useApplicationContext();

  const [isFullPhone, setIsFullPhone] = React.useState(false);
  const [dynamicPhone, setDynamicPhone] = React.useState<string | null>(null);

  const phone = dynamicPhone || cropPhone({ phone: target.phone, isFullPhone });

  const showPhone = React.useCallback(async () => {
    setIsFullPhone(true);

    if (!isTablet()) {
      trackAction(target);
    }
  }, [target, trackAction]);

  const handleClick = React.useCallback(async () => {
    if (isFullPhone) {
      window.location.href = `tel:${phone}`;

      return;
    }

    if (blockId) {
      const response = await handleDynamicCalltracking({
        logger,
        httpApi,
        blockId,
        platformType: EPlatformTypes.WebMobile,
        pageType: EPageTypes.NewbuildingCard,
        placeType,
      });

      setDynamicPhone(stringToFormattedPhone(response.notFormattedPhone));
    }

    showPhone();
  }, [httpApi, isFullPhone, logger, phone, placeType, blockId, showPhone]);

  return (
    <Button size="XS" theme="fill_secondary" onClick={handleClick}>
      {phone}
    </Button>
  );
};
